import { WrenchTheme } from '@wds/styles';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  ({ spacing, bgColor, semanticColor, borderRadius }: typeof WrenchTheme) => ({
    forbiddenError: () => ({
      textAlign: 'center',
      backgroundColor: bgColor.bg,
      display: 'flex',
      justifyContent: 'center',
      padding: 150,
    }),
    forbiddenErrorMessageWrapper: () => ({
      minWidth: 550,
      margin: spacing[1], // should be spacing 0
      position: 'unset',
    }),
    forbiddenErrorMessageContainer: () => ({
      padding: spacing[6],
      backgroundColor: bgColor.light,
      border: `1px solid ${semanticColor.muted}`,
      borderRadius: borderRadius.small,
      marginTop: spacing[4],
    }),
    forbiddenErrorLinksContainer: () => ({
      overflow: 'hidden',
      margin: spacing[4],
      position: 'relative',
    }),
    forbiddenErrorLinksList: () => ({
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      listStyleType: 'none',
      marginLeft: -1,
    }),
    forbiddenErrorLinksListItem: () => ({
      flexGrow: 1,
      flexBasis: 'auto',
      textAlign: 'center',
      borderRight: '1px solid #ccc',
      backgroundColor: bgColor.light,

      '&:last-child': {
        borderRight: 'none',
      },
    }),
  })
);

export default useStyles;
